import { AfterViewInit, Component, ElementRef } from '@angular/core';

@Component({
  selector: 'app-public-help',
  templateUrl: './public-help.component.html',
  styleUrls: ['./public-help.component.scss'],
  standalone: false,
})
export class PublicHelpComponent implements AfterViewInit {
  private readonly tablist = ['faq-tab', 'trainings-tab', 'user-guides-tab', 'contact-us-tab'];
  private tabs: HTMLElement[] = [];
  private tabpanels: HTMLElement[] = [];
  private firstTab: HTMLElement;
  private lastTab: HTMLElement;

  isTrainings = false;
  isUserGuides = false;
  isFaq = false;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    setTimeout(() => this.setFocus());
  }

  private setFocus(): void {
    this.tabs = this.tablist
      .map((id) => this.el.nativeElement.querySelector(`#${id}`))
      .filter((element) => element !== null);
    this.tabpanels = this.tabs.map((tab) =>
      this.el.nativeElement.querySelector(`#${tab.getAttribute('aria-controls')}`)
    );
    this.firstTab = this.tabs[0];
    this.lastTab = this.tabs[this.tabs.length - 1];
    this.setSelectedTab(this.firstTab, false);
  }

  private setSelectedTab(currentTab: HTMLElement, setFocus = true): void {
    this.tabs.forEach((tab, index) => {
      if (currentTab === tab) {
        tab.setAttribute('aria-selected', 'true');
        tab.tabIndex = 0;
        this.tabpanels[index].classList.add('show', 'active');
        tab.classList.add('active');
        if (setFocus) {
          tab.focus();
        }
        this.enableTab(tab.id);
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;
        this.tabpanels[index].classList.remove('show', 'active');
        tab.classList.remove('active');
        this.disableTab(tab.id);
      }
    });
  }

  private enableTab(tabId: string): void {
    this.isFaq = tabId === 'faq-tab';
    this.isTrainings = tabId === 'trainings-tab';
    this.isUserGuides = tabId === 'user-guides-tab';
  }

  private disableTab(tabId: string): void {
    if (tabId === 'trainings-tab') {
      this.isTrainings = false;
    } else if (tabId === 'user-guides-tab') {
      this.isUserGuides = false;
    }
    else if (tabId === 'faq-tab') {
      this.isFaq = false;
    }
  }

  onClick(event: Event): void {
    this.setSelectedTab(event.currentTarget as HTMLElement);
  }

  onKeydown(event: KeyboardEvent): void {
    const target = event.currentTarget as HTMLElement;
    let handled = false;

    switch (event.key) {
      case 'ArrowLeft':
        this.setSelectedToPreviousTab(target);
        handled = true;
        break;
      case 'ArrowRight':
        this.setSelectedToNextTab(target);
        handled = true;
        break;
      case 'Home':
        this.setSelectedTab(this.firstTab);
        handled = true;
        break;
      case 'End':
        this.setSelectedTab(this.lastTab);
        handled = true;
        break;
    }

    if (handled) {
      event.preventDefault();
    }
  }

  private setSelectedToNextTab(currentTab: HTMLElement): void {
    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab);
      return;
    }
    const index = this.tabs.indexOf(currentTab);
    this.setSelectedTab(this.tabs[index + 1]);
  }

  private setSelectedToPreviousTab(currentTab: HTMLElement): void {
    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab, false);
      return;
    }
    const index = this.tabs.indexOf(currentTab);
    this.setSelectedTab(this.tabs[index - 1], false);
  }
}
